import { render, staticRenderFns } from "./EditGoalDialog.vue?vue&type=template&id=1665b845&scoped=true"
import script from "./EditGoalDialog.vue?vue&type=script&lang=js"
export * from "./EditGoalDialog.vue?vue&type=script&lang=js"
import style0 from "./EditGoalDialog.vue?vue&type=style&index=0&id=1665b845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1665b845",
  null
  
)

export default component.exports